import { makeStyles, Theme } from '@material-ui/core';

export const usePostConditionStyles = makeStyles<Theme>((theme) => ({
  wrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: 24,
  },
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    borderRadius: '12px',
    background: 'var(--color-black-3)',
  },
  pcItem: {
    display: 'flex',
    flexDirection: 'column',
    margin: 24,
  },
  pcTitle: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '20px',
    color: '#FAFAFA',
    marginBottom: 16,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      marginBottom: 12,
    },
  },
  assetContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: '32px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '16px',
    },
  },
  assetTitle: {
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '20px',
    color: '#FAFAFA',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  tokenInfoContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '32px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '16px',
    },
  },
  pcSymbol: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    color: '#ABABAB',
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
    },
  },
  tokenContract: {
    display: 'flex',
    flexDirection: 'row',
    gap: '4px',
    alignItems: 'center',
  },
  tokenContractText: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    color: '#FAFAFA',
    marginRight: 4,
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
    },
  },
  copyIcon: {
    cursor: 'pointer',
  },
  linkIcon: {
    display: 'flex',
  },
  separator: {
    borderColor: '#FFFFFF1A',
  },
  pcMessage: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '20px',
    padding: '8px 16px',
    borderRadius: '8px',
    background: '#34353B',
    color: '#ABABAB',
  },
  pcMessageAmount: {
    color: '#FAFAFA',
  },
  modeContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  warning: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 4,
    border: '1px solid #FDAC5D',
    borderRadius: '8px',
    background: '#34353B',
    padding: '8px 16px',
  },
  warningTitle: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '20px',
    color: '#FAFAFA',
  },
  warningText: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    color: '#ABABAB',
  },
}));
